export const getRouterParams = state => state.app.router.params;
export const getRouterLocation = state => state.app.router.location;
